import styled from "styled-components";

export const LoadingWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 50%;
  z-index: 1000;
`;
